<template>
  <div class="v-page-layout">

    <div class="navigation">
      <div v-if="!noCard" class="page-header">
        <h4 class="title">
          {{ title }}
        </h4>
      </div>
      <div class="navigator" :class="{ 'ml-3': noCard }">
        <button class="btn" @click.prevent="redirectToTradeRoom">
          <i class="fas fa-home" /> {{ $t('pagelayout.home') }}
        </button>
        <span class="ds">/</span>
        <back />
      </div>
    </div>

    <div :class="{ 'page-content': noCard, 'page-content': !noCard }">
      <slot /> 
    </div>

  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import BackButton from './BackButton';

export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: false,
    },
    item: {
      type: String,
      required: false,
    },
    noCard: {
      type: Boolean,
      required: false,
      default: false,
    }
  },
  components: {
    'back': BackButton,
  },
  methods: {
    redirectToTradeRoom() {
      this.$router.push({ name: this.stockType === '1' ? 'trade-ipo' : 'trade-sto' });
    },
  },
  computed: {
    ...mapState('brand', ['stockType']),
  }
} 
</script>

<style lang="scss" src="../../sass/partials/page-layout.scss"></style>
